export default __webpack_public_path__ + "static/media/pic6.07f5a5f3.jpeg";